export const SELECTED_MAKE_MODEL_YEAR = "SELECTED_MAKE_MODEL_YEAR";

export function selectedMakeModelYear(payload){
    return { type: SELECTED_MAKE_MODEL_YEAR, payload };
}

